import { put, takeLatest, call } from "redux-saga/effects";
import {
  SETTINGS_PAGE_LOAD,
  settingsLoaded,
} from "../../actions/global-settings";
import getContactDetails from "sc/backend/oncall/partners/contact-details/get";
import { showErrorPage } from "../../../../../actions/ui/location";

const settingsPageLoadSaga = function*(action) {
  try {
    const result = yield call(getContactDetails);
    yield put(settingsLoaded(result));
  } catch (ignore) {
    yield put(showErrorPage());
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(SETTINGS_PAGE_LOAD, settingsPageLoadSaga);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/global-settings/edit-page-load.js